// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu10 = () => {
    const { menuDashboard10 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard10?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard10.id,
        title: <FormattedMessage id={`${menuDashboard10.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard10.icon],
        type: menuDashboard10.type,
        children: ChildrenList
    };

    return dashboardList;
};
